<template>
  <div>
    <h1>Prévisionnel sur TOP 50 Fournisseur CMEM</h1>
    <div>
      <a v-if="selectedMember && isSaisieScreen" href="/static/Documentation adherent saisie.pdf" target="_blank" class="btn btn-warning">Mode d'emploi</a>
      <a v-else href="/static/Documentation adherent resultats.pdf" target="_blank" class="btn btn-warning">Mode d'emploi</a>
    </div>
    <br />
    <SubstituteAdh :members="isSaisieScreen ? [selectedMember] : members" :selectedMemberGuid="selectedMemberGuid" @update="selectedMemberGuid = $event; onlyCdm = false"></SubstituteAdh>
    <label v-if="paramSaisieSoc && selectedMember && selectedMember.Level == 3"><input type="checkbox" :checked="socSaisiePrevi.indexOf(selectedMember.Guid) !== -1" @click="toggleSocSaisie"/> Saisie à la société</label>
    <div class="saisie-container" v-if="isSaisieScreen">
      <div class="d-flex justify-content-between">
        <h2>Saisie</h2>
        <button class="btn btn-success" v-on:click="exportDatas('saisie')">Exporter sous Excel</button>
      </div>
      <div class="d-flex justify-content-between">
        <small>* Le CA {{currentYear}} est estimé via les acomptes</small>
        <small class="text-danger">Pour chaque ligne, vous devez cliquer sur "Sauvegarder la ligne" pour enregistrer vos modifications</small>
      </div>
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Fournisseur</th>
            <th>Code</th>
            <th class="bordered">Famille</th>
            <th>CA {{currentYear - 2}}</th>
            <th>CA {{currentYear - 1}}</th>
            <th>Part de Marché {{currentYear - 1}}</th>
            <th class="bordered">Progression {{currentYear - 2}}/{{currentYear - 1}} (%)</th>
            <th>CA {{currentYear}}</th>
            <th class="bordered">Progression {{currentYear - 1}}/{{currentYear}} (%)</th>
            <th>Objectif CA {{currentYear + 1}}</th>
            <th>Objectif Progression {{currentYear - 1}}/{{currentYear + 1}} (%)</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="frs of frsDataList" :key="frs.Guid">
            <td>{{frs.Name}} {{frs.IsNEstimated ? "*" : ""}}</td>
            <td>{{frs.IdCompta}}</td>
            <td class="bordered">{{frs.FamilyCode}}</td>
            <td class="nb">{{formatNbEur(frs.CAN2)}}</td>
            <td class="nb">{{formatNbEur(frs.CAN1)}}</td>
            <td class="nb">{{formatNbPercent(frs.FrsPropFromAdh / 100)}}</td>
            <td class="nb bordered" :class="frs.n2Progress > 0 ? 'green' : frs.n2Progress < 0 ? 'red' : ''">{{formatNbPercent(frs.n2Progress)}}</td>
            <td class="nb">{{formatNbEur(frs.CANEstimated)}}</td>
            <td class="nb bordered" :class="frs.n1Progress > 0 ? 'green' : frs.n1Progress < 0 ? 'red' : ''">{{frs.CANEstimated === 0 ? "" : formatNbPercent(frs.n1Progress)}}</td>
            <td><input type="number" class="form-control" :placeholder="formatNbEur(frs.ProgressIsNull ? '' : frs.NProgression)" :value="frsPrevi[frs.Guid] && frsPrevi[frs.Guid].ca" @keyup="updatePrevi($event, frs.Guid)" /></td>
            <td><input type="number" class="form-control" :placeholder="formatNbPercent(frs.ProgressIsNull || frs.CAN1 == 0 ? 0 : (frs.NProgression - frs.CAN1) / frs.CAN1)" :value="frsPrevi[frs.Guid] && frsPrevi[frs.Guid].percent" @keyup="updatePreviPercent($event, frs.Guid)" /></td>
            <td class="btn-group">
              <button class="btn btn-success" @click="validPrevi(frs.Guid)" v-if="frsPrevi[frs.Guid] && frsPrevi[frs.Guid].ca !== '' && (frsPrevi[frs.Guid].ca != frs.NProgression || frs.ProgressIsNull)">Sauvegarder la ligne</button>
              <button class="btn btn-danger" @click="validPrevi(frs.Guid, true)" v-if="!frs.ProgressIsNull"><font-awesome-icon icon="trash"></font-awesome-icon></button>
            </td>
          </tr>
          <tr class="table-info">
            <td>Total</td>
            <td></td>
            <td></td>
            <td class="nb">{{formatNbEur(frsDataListTotals.CAN2)}}</td>
            <td class="nb">{{formatNbEur(frsDataListTotals.CAN1)}}</td>
            <td class="nb bordered">{{formatNbPercent(frsDataListTotals.FrsPropFromAdh / 100)}}</td>
            <td class="nb" :class="frsDataListTotals.n2Progress > 0 ? 'green' : frsDataListTotals.n2Progress < 0 ? 'red' : ''">{{formatNbPercent(frsDataListTotals.n2Progress)}}</td>
            <td class="nb">{{formatNbEur(frsDataListTotals.CANEstimated)}}</td>
            <td class="nb bordered" :class="frsDataListTotals.n1Progress > 0 ? 'green' : frsDataListTotals.n1Progress < 0 ? 'red' : ''">{{formatNbPercent(frsDataListTotals.n1Progress)}}</td>
            <td class="nb">{{formatNbEur(frsDataListTotals.NProgression)}}</td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="result-container" v-else>
      <button class="btn btn-success" v-on:click="exportDatas('prevision')">Exporter sous Excel</button>
      <h2>Résultats des saisies</h2>
      <label v-if="selectedMember && selectedMember.Level == 0"><input type="checkbox" v-model="onlyCdm"/> Uniquement mes fournisseurs</label>
      <small>* Le CA {{currentYear}} est estimé via les acomptes</small>
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Fournisseur</th>
            <th>Code</th>
            <th class="bordered">Famille</th>
            <th>CA Fournisseur {{currentYear - 2}}</th>
            <th>CA Fournisseur {{currentYear - 1}}</th>
            <th>Part de Marché {{currentYear - 1}}</th>
            <th class="bordered">Progression {{currentYear - 2}}/{{currentYear - 1}} (%)</th>
            <th>CA {{currentYear}}</th>
            <th class="bordered">Progression {{currentYear - 1}}/{{currentYear}} (%)</th>
            <th>CA Participants {{currentYear - 1}}</th>
            <th>% de participation (pondéré sur CA {{currentYear - 1}})</th>
            <th>Objectif CA {{currentYear + 1}}</th>
            <th>Objectif Progression {{currentYear - 1}}/{{currentYear + 1}} (%)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="frs of filteredCdmResults" :key="frs.Guid">
            <td>
              <router-link v-if="selectedMember.Guid == me.Guid" :to="{ path: 'previsionnel-top-frs-supplier', query: { frsGuid: frs.Guid, frsName: frs.Name}}">{{frs.Name}} {{frs.IsNEstimated ? "*" : ""}}</router-link>
              <span v-else>{{frs.Name}} {{frs.IsNEstimated ? "*" : ""}}</span>
            </td>
            <td>{{frs.IdCompta}}</td>
            <td class="bordered">{{frs.FamilyCode}}</td>
            <td class="nb">{{formatNbEur(frs.CaFrsN2)}}</td>
            <td class="nb">{{formatNbEur(frs.CaFrs)}}</td>
            <td class="nb">{{formatNbPercent(frs.FrsPropFromAdh / 100)}}</td>
            <td class="nb bordered" :class="frs.n2Progress > 0 ? 'green' : frs.n2Progress < 0 ? 'red' : ''">{{formatNbPercent(frs.n2Progress)}}</td>
            <td class="nb">{{formatNbEur(frs.CaFrsNEstimated)}}</td>
            <td class="nb bordered" :class="frs.n1Progress > 0 ? 'green' : frs.n1Progress < 0 ? 'red' : ''">{{frs.CaFrsNEstimated === 0 ? "" : formatNbPercent(frs.n1Progress)}}</td>
            <td class="nb">{{formatNbEur(frs.CaParticipants)}}</td>
            <td class="nb">{{formatNbPercent(frs.PercentParticipants / 100)}}</td>
            <td class="nb">{{formatNbEur(frs.CaPreviParticipants)}}</td>
            <td class="nb">{{formatNbPercent(frs.PreviProgress / 100)}}</td>
          </tr>
          <tr class="table-info">
            <td>Total</td>
            <td></td>
            <td class="bordered"></td>
            <td class="nb">{{formatNbEur(frsPreviResultsTotals.CaFrsN2)}}</td>
            <td class="nb">{{formatNbEur(frsPreviResultsTotals.CaFrs)}}</td>
            <td class="nb">{{formatNbPercent(frsPreviResultsTotals.FrsPropFromAdh / 100)}}</td>
            <td class="nb bordered">{{formatNbPercent(frsPreviResultsTotals.n2Progress)}}</td>
            <td class="nb">{{formatNbEur(frsPreviResultsTotals.CaFrsNEstimated)}}</td>
            <td class="nb bordered">{{formatNbPercent(frsPreviResultsTotals.n1Progress)}}</td>
            <td class="nb">{{formatNbEur(frsPreviResultsTotals.CaParticipants)}}</td>
            <td class="nb">{{formatNbPercent(frsPreviResultsTotals.PercentParticipants)}}</td>
            <td class="nb">{{formatNbEur(frsPreviResultsTotals.CaPreviParticipants)}}</td>
            <td class="nb">{{formatNbPercent(frsPreviResultsTotals.PreviProgress)}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
  import SubstituteAdh from "@/components/SubstituteAdh";
  import ExcelJS from "exceljs";

  import { getUserModuleRights } from "@/utils/module";
  import { getAllMembersHierarchy, getSocSaisiePrevi, toggleSocSaisiePrevi } from "@/utils/member";
  import { getParameterByCode } from "@/utils/param";
  import {
    getFrsList,
    getTopFrsList,
    updatePreviPdvFrs,
    getTopFrsPreviResults
  } from "@/utils/frs";

  export default {
    name: "TopFrsPrevisionnel",
    components: {
      SubstituteAdh
    },
    data() {
      return {
        members: [],
        frsDataList: [],
        onlyCdmFrsList: [],
        onlyCdm: false,
        selectedMemberGuid: "",
        frsPrevi: {},
        frsPreviResults: [],
        socSaisiePrevi: [],
        currentYear: -1,
        paramSaisieSoc: false
      }
    },
    mounted() {
      // Récupère le boolean, vrai si la saisie à la société est autorisée, faux sinon
      getParameterByCode("FRS_PREVI_SAISIE_SOCIETE").then(res => {
        this.paramSaisieSoc = res == 1;
        if (this.paramSaisieSoc) { // Si elle est autorisée, on récupère la liste des sociétés (enfant) qui ont choisi la saisie à la société
          getSocSaisiePrevi().then(_res => {
            this.socSaisiePrevi = _res
            getParameterByCode("ANNEE_COURANTE").then(res => {
              this.currentYear = parseInt(res);
            })
            getAllMembersHierarchy().then(res => {
              this.members = res;
            })
          });
        } else {
          getParameterByCode("ANNEE_COURANTE").then(res => {
            this.currentYear = parseInt(res);
          })
          getAllMembersHierarchy().then(res => {
            this.members = res;
          })
        }

      })
      // On récupère l'année de saisie actuelle
    },
    watch: {
      selectedMember() {
        if (!this.selectedMember || !this.selectedMember.Guid) return;

        if (this.selectedMember.Level === 0 && this.onlyCdmFrsList.length === 0) {
          // On est au niveau admin et la liste n'a pas été initialisée
          getFrsList().then(res => { // On récupère la liste des frs liés au CDM
            this.onlyCdmFrsList = res;
          })
        }

        if (!this.isSaisieScreen) {
          this.getFrsResults();
        } else {
          this.getFrsDataList().then(() => {
            this.frsPrevi = {};
            for (let frs of this.frsDataList) {
              this.frsPrevi[frs.Guid] = "";
            }
            this.frsPrevi = this.frsPrevi;
          })
        }
      }
    },
    computed: {
      // Récupération des informations sur l'utilisateur courant
      me() {
        let minLevel = this.members.reduce((acc, el) => el.Level < acc ? el.Level : acc, 5)
        if (this.$store.state.self.isAdmin && minLevel === 1 && this.members.filter(el => el.Level === minLevel).length > 1) {
          minLevel = 0; // CMEM
        }
        return this.members.find(el => el.Level === minLevel) || ({ Name: "Admin", Level: 0, Label: "[A] Admin", Guid: "00000000-0000-0000-0000-000000000000" });
      },
      // Récupération des informations sur l'adhérent sélectionné (via substitution)
      selectedMember() {
        if (!this.selectedMemberGuid) return this.me
        return this.members.find(el => el.Guid === this.selectedMemberGuid) || this.me
      },
      // Vrai si l'écran à afficher est celui de saisie, faux sinon
      isSaisieScreen() {
        return this.selectedMember && // vrai si niveau pdv, ou niveau société et saisie société activée
          (this.selectedMember.Level == 4 ||
            (this.selectedMember.Level == 3
              && this.socSaisiePrevi.indexOf(this.selectedMember.Guid) !== -1
            )
          )
      },
      // Résultats filtrés au cdm connecté si coché
      filteredCdmResults() {
        return this.frsPreviResults.filter(el => !this.onlyCdm || this.onlyCdmFrsList.find(_el => _el.Guid === el.Guid) != null)
      },
      // Ligne de totaux écran de saisie
      frsDataListTotals() {
        const CAN2 = this.frsDataList.reduce((acc, el) => acc + el.CAN2, 0);
        const CAN1 = this.frsDataList.reduce((acc, el) => acc + el.CAN1, 0);
        const FrsPropFromAdh = this.frsDataList.reduce((acc, el) => acc + el.FrsPropFromAdh, 0);
        const n2Progress = CAN2 == 0 ? 0 : (CAN1 - CAN2) / CAN2;
        const CANEstimated = this.frsDataList.reduce((acc, el) => acc + el.CANEstimated, 0);
        const n1Progress = CAN1 == 0 ? 0 : (CANEstimated - CAN1) / CAN1;
        const NProgression = this.frsDataList.reduce((acc, el) => acc + el.NProgression, 0);

        return { CAN2, CAN1, FrsPropFromAdh, n2Progress, CANEstimated, n1Progress, NProgression }
      },
      // Ligne de totaux écran de résultats
      frsPreviResultsTotals() {
        const CaFrsN2 = this.filteredCdmResults.reduce((acc, el) => acc + el.CaFrsN2, 0);
        const CaFrs = this.filteredCdmResults.reduce((acc, el) => acc + el.CaFrs, 0);
        const CaFrsNEstimated = this.filteredCdmResults.reduce((acc, el) => acc + el.CaFrsNEstimated, 0);
        const n2Progress = CaFrsN2 == 0 ? 0 : (CaFrs - CaFrsN2) / CaFrsN2;
        const n1Progress = CaFrs == 0 ? 0 : (CaFrsNEstimated - CaFrs) / CaFrs;
        const FrsPropFromAdh = this.filteredCdmResults.reduce((acc, el) => acc + el.FrsPropFromAdh, 0);
        const CaParticipants = this.filteredCdmResults.reduce((acc, el) => acc + el.CaParticipants, 0);
        const CaPreviParticipants = this.filteredCdmResults.reduce((acc, el) => acc + el.CaPreviParticipants, 0);
        const PercentParticipants = CaParticipants / CaFrs;
        const PreviProgress = CaParticipants == 0 ? 0 : (CaPreviParticipants - CaParticipants) / CaParticipants;

        return { CaFrsN2, CaFrsNEstimated, CaFrs, n2Progress, n1Progress, FrsPropFromAdh, CaParticipants, CaPreviParticipants, PercentParticipants, PreviProgress }
      }
    },
    methods: {
      // Le champ CA Prévu N + 1 a été modifié (on synchronise le % progression)
      updatePrevi(e, frsGuid) {
        try {
          const newCa = parseFloat(e.target.value);
          if (isNaN(newCa)) throw 'Not a number'
          const frs = this.frsDataList.find(el => el.Guid == frsGuid);
          if (!frs) return;
          const frsCaN1 = frs.CAN1;
          this.frsPrevi = {
            ...this.frsPrevi, [frsGuid]: { ca: e.target.value, percent: frsCaN1 == 0 ? 0 : parseInt(((newCa - frsCaN1) / frsCaN1 * 100) * 100) / 100 }
          }
        } catch (err) {
          this.frsPrevi = {
            ...this.frsPrevi, [frsGuid]: { ca: e.target.value, percent: "" }
          }
        }
      },
      // Le champ % progression N + 1 a été modifié (on synchronise le CA Prévu N + 1)
      updatePreviPercent(e, frsGuid) {
        try {
          const newPercent = parseFloat(e.target.value);
          if (isNaN(newPercent)) throw 'Not a number'
          const frs = this.frsDataList.find(el => el.Guid == frsGuid);
          if (!frs) return;
          const frsCaN1 = frs.CAN1;
          this.frsPrevi = {
            ...this.frsPrevi, [frsGuid]: { ca: parseInt((frsCaN1 + (frsCaN1 * newPercent / 100)) * 100) / 100, percent: e.target.value }
          }
        }
        catch (err) {
          this.frsPrevi = {
            ...this.frsPrevi, [frsGuid]: { ca: "", percent: e.target.value }
          }
        }
      },
      // On valide une déclaration de CA Prévu
      validPrevi(frsGuid, del = false) {
        if (!this.frsPrevi[frsGuid] && !del) return; // On ajoute/modifie une déclaration sans remplir d'informations

        if (del) {
          const validation = window.confirm("Voulez-vous vraiment supprimer votre déclaration ?");
          if (validation) {
            updatePreviPdvFrs(this.selectedMember.Guid, frsGuid, null, true).then((res) => {
              if (res == "OK") {
                var frs = this.frsDataList.find(frs => frs.Guid == frsGuid)
                frs.NProgression = 0;
                frs.ProgressIsNull = true;
                this.frsDataList = this.frsDataList
                this.frsPrevi[frsGuid] = undefined;
                //this.getFrsDataList();
              }
            })
          }
        } else {
          updatePreviPdvFrs(this.selectedMember.Guid, frsGuid, this.frsPrevi[frsGuid].ca, false).then((res) => {
            if (res == "OK") {
              var frs = this.frsDataList.find(frs => frs.Guid == frsGuid)
              frs.NProgression = this.frsPrevi[frsGuid].ca;
              frs.ProgressIsNull = false;
              this.frsDataList = this.frsDataList
              this.frsPrevi[frsGuid] = undefined;
            //this.getFrsDataList();
            }
          })
        }
      },
      // On inverse la saisie à la société
      toggleSocSaisie(e) {
        e.preventDefault();
        if (this.selectedMember && this.selectedMember.Level == 3) {
          let confirm = window.confirm("Les données saisies au point de vente seront supprimées. Voulez vous continuer ?")
          if (!confirm) return;

          toggleSocSaisiePrevi(this.selectedMember.Guid).then((res) => {
            if (res == "OK") {
              getSocSaisiePrevi().then(_res => {
                this.socSaisiePrevi = _res
                if (this.socSaisiePrevi.indexOf(this.selectedMember.Guid !== -1)) {
                  // On va afficher l'écran de saisie, il faut récupérer les données
                  if (!this.isSaisieScreen) {
                    this.getFrsResults();
                  } else {
                    this.getFrsDataList().then(() => {
                      this.frsPrevi = {};
                      for (let frs of this.frsDataList) {
                        this.frsPrevi[frs.Guid] = "";
                      }
                      this.frsPrevi = this.frsPrevi;
                    })
                  }
                }
              });
            }
          })
        }
      },
      getFrsDataList() {
        return new Promise((resolve) => {
          getTopFrsList(this.selectedMember.Guid).then(res => {
            this.frsDataList = res
              .map(f => ({
                ...f,
                n2Progress: f.CAN2 ? ((f.CAN1 - f.CAN2) / f.CAN2) : 0,
                n1Progress: f.CAN1 ? ((f.CANEstimated - f.CAN1) / f.CAN1) : 0
              }))
              .sort((a, b) => {
                if (a.CAN1 > b.CAN1) return -1;
                else if (a.CAN1 < b.CAN1) return 1;
                else if (a.Name < b.Name) return -1;
                else if (a.Name > b.Name) return 1;
                return 1;
              });
            resolve();
          })
        })
      },
      getFrsResults() {
        return new Promise((resolve) => {
          getTopFrsPreviResults(this.selectedMember.Level === 0 ? "" : this.selectedMember.Guid).then(res => {
            this.frsPreviResults = res
              .map(f => ({
                ...f,
                n2Progress: f.CaFrsN2 ? ((f.CaFrs - f.CaFrsN2) / f.CaFrsN2) : 0,
                n1Progress: f.CaFrs ? ((f.CaFrsNEstimated - f.CaFrs) / f.CaFrs) : 0
              }))
              .sort((a, b) => {
                if (a.CaFrs > b.CaFrs) return -1;
                else if (a.CaFrs < b.CaFrs) return 1;
                else if (a.Name < b.Name) return -1;
                else if (a.Name > b.Name) return 1;
                return 1;
              });
            resolve();
          })
        })
      },
      formatNbEur(n) {
        return n.toLocaleString("fr-FR", { maximumFractionDigits: 0 });
      },
      formatNbPercent(n) {
        return n.toLocaleString("fr-FR", { style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2 })
      },

      // Lance l'export Excel après un clic sur le bouton 
      exportDatas(scope) {

        // On crée le fichier Excel
        const wb = new ExcelJS.Workbook();
        const ws =  wb.addWorksheet('sheet', {
          pageSetup:{paperSize: 1, orientation:'landscape'}
        });

        if (scope == "prevision") {
          // On crée l'objet de données et on lui affecte les valeurs
          var datas = [];
          this.frsPreviResults.forEach(item => {
            var d = [];
            d[0] = item.Name;
            d[1] = item.IdCompta;
            d[2] = item.FamilyCode;
            d[3] = item.CaFrsN2;
            d[4] = item.CaFrs;
            d[5] = item.CaFrsN2 == 0 ? 0 : ((item.CaFrs / item.CaFrsN2) - 1) * 100;
            d[6] = item.CaFrsNEstimated;
            d[7] = item.CaParticipants;
            d[8] = item.PercentParticipants;
            d[9] = item.CaPreviParticipants;
            d[10] = item.PreviProgress;

            datas.push(d);
          });

          ws.addTable({
            name: 'MyTable',
            ref: 'A1',
            headerRow: true,
            totalsRow: false,
            columns: [
              { name: 'Fournisseur' },
              { name: 'Code Compta' },
              { name: 'Famille' },
              { name: 'CA N-2' },
              { name: 'CA N-1' },
              { name: 'Progression %' },
              { name: 'CA N Estimé (via acomptes)' },
              { name: 'CA Participants' },
              { name: '% Participation' },
              { name: 'CA Prévue N + 1' },
              { name: 'Progression prévue N + 1 (%)' },
            ],
            rows: datas,
          });

          this.saveWb(wb, "Résultats Prévisionnels " + this.currentYear + " " + this.selectedMember.Name + (this.selectedMember.IdCompta ? (" (" + this.selectedMember.IdCompta + ")") : ""));
        }
        else if (scope == "saisie") {
          // On crée l'objet de données et on lui affecte les valeurs
          var datas = [];
          this.frsDataList.forEach(item => {
            var d = [];
            d[0] = item.Name;
            d[1] = item.IdCompta;
            d[2] = item.FamilyCode;
            d[3] = item.CAN2;
            d[4] = item.CAN1;
            d[5] = item.CAN2 == 0 ? 0 : ((item.CAN1 / item.CAN2) - 1) * 100;
            d[6] = item.CANEstimated;
            d[7] = item.NProgression;
            d[8] = item.CAN1 == 0 ? 0 : ((item.NProgression / item.CAN1) - 1) * 100;

            datas.push(d);
          });

          ws.addTable({
            name: 'MyTable',
            ref: 'A1',
            headerRow: true,
            totalsRow: false,
            columns: [
              { name: 'Fournisseur' },
              { name: 'Code Compta' },
              { name: 'Famille' },
              { name: 'CA N-2' },
              { name: 'CA N-1' },
              { name: 'Progression %' },
              { name: 'CA N Estimé (via acomptes)' },
              { name: 'CA Prévue N + 1' },
              { name: 'Progression prévue N + 1 (%)' },
            ],
            rows: datas,
          });

          this.saveWb(wb, "Saisie Prévisionnelle " + this.currentYear + " " + this.selectedMember.Name + " (" + this.selectedMember.IdCompta + ")");
        }
        
      },

      // Télécharge le fichier excel
      saveWb(wb, name="test_previ") {
        wb.xlsx.writeBuffer().then((data) => {
          const blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          const now = new Date();
          const datetimeString = now.getDate() + "/" + (now.getMonth() + 1) + "/" + now.getFullYear() + " " + now.getHours() + ":" + now.getMinutes() + ":" + now.getSeconds();
          saveAs(blob, name + " " + datetimeString + ".xlsx");
        })
      }
    }
  }
</script>

<style scoped>
  .saisie-container, .result-container {
    margin-top: 48px;
  }

  table {
      background: #FFFFFF;
      border-radius: 5px;
      font-size: 0.9em;
  }
      table > thead > tr > th {
          padding-top: 15px;
          padding-bottom: 15px;
          font-weight: 100;
          font-size: 1.2em;
          text-align: center;
          vertical-align: middle;
      }

    table > tbody {
        border-top: solid 2px #999999 !important;
    }

    table .table-info {
      font-weight: bold;
    }

  td.bordered, th.bordered {
    border-right: 1px solid #EEE;
  }

  td.nb {
    text-align: right;
  }

  td.green {
    color: #30CC30 !important;
  }
  td.red {
    color: #CC3030 !important;
  }

  h2 {
      font-weight: 100;
      font-size: 1.6em;
  }

  .btn {
      float: right;
      margin-bottom: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Achat/TopFrsPrevisionnel.vue